<template>
  <div class="flex items-center justify-center h-full">
    <ObjectOwnerBadge
      v-if="ownerData"
      :owner-id="ownerData.ownerId"
      :owner-type="ownerData.ownerType"
      :owner-name="ownerData.ownerName"
      :owner-color="ownerData.ownerColor"
      :object-content-type-model="ownerData.objectContentTypeModel"
      :object-id="ownerData.objectId"
      @update-owner="emitUpdateOwner"
      @close="handleClose"
    />
    <div v-else class="flex items-center justify-center rounded-full w-7 h-7 bg-gray-300">
      <span class="text-xs text-gray-600">N/A</span>
    </div>
  </div>
</template>

<script>
import ObjectOwnerBadge from '@/components/widgetcomponents/ObjectOwnerBadge.vue';

export default {
  name: 'CC_Owner_Badge',
  components: {
    ObjectOwnerBadge
  },
  data() {
    return {
      ownerData: null
    };
  },
  created() {
    this.updateOwnerData();
  },
  methods: {
    updateOwnerData() {
      // Get owner data from params
      if (this.params.getOwnerData) {
        this.ownerData = this.params.getOwnerData(this.params);
      } else {
        // Fallback to direct data mapping
        this.ownerData = {
          ownerId: this.params.data.action_owner_object_id,
          ownerType: this.params.data.action_owner_content_type_model,
          ownerName: this.params.data.action_owner_name,
          ownerColor: this.params.data.action_owner_color || '#3B82F6',
          objectContentTypeModel: 'action',
          objectId: this.params.data.object_id
        };
      }
    },
    handleClose() {
      // Refresh the data after owner update
      if (this.params.refreshData) {
        this.params.refreshData();
      }
    },
    emitUpdateOwner(data) {
      this.params?.on?.['update-owner']?.(data);
    }
  }
};
</script>
